import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export type DriverLocation = {
  driver_id: number;
  license_number: string;
  longitude: string;
  latitude: string;
  time: string | null;
  trip_id: number | null;
};

export interface DriverTrackingState {
  locationsByDriverId: Record<number, DriverLocation>;
  connected: boolean;
}

const initialState: DriverTrackingState = {
  locationsByDriverId: {},
  connected: false,
};

export const driverTrackingSlice = createSlice({
  name: 'driverTracking',
  initialState,
  reducers: {
    updateDriverLocations: (state, { payload }: PayloadAction<{ locations: DriverLocation[] }>) => {
      payload.locations.forEach((loc) => {
        state.locationsByDriverId[loc.driver_id] = loc;
      });
    },
    setTrackingConnected: (state, { payload }: PayloadAction<boolean>) => {
      state.connected = payload;
    },
    clearDriverLocations: (state) => {
      state.locationsByDriverId = {};
    },
  },
});

export const { updateDriverLocations, setTrackingConnected, clearDriverLocations } = driverTrackingSlice.actions;

const driverTrackingStore = (store: RootState): DriverTrackingState => store.driverTracking;

export const getDriverLocationsList = createSelector(driverTrackingStore, (s) => Object.values(s.locationsByDriverId));

export const getTrackingConnected = createSelector(driverTrackingStore, (s) => s.connected);

export default driverTrackingSlice.reducer;
